import Login from "./pages/Login/Login";
import Cadastro from "./pages/Cadastro/Cadastro";
import DashboardInicio from "./pages/Dashboard-Inicio/DashboardInicio";
import Video from "./pages/Introducao/Video";
import TextIntro from "./pages/Introducao/TextIntro";
import TermoCooperacao from "./pages/Termo/TermoCooperacao";
import PreenchaDados from "./pages/Termo/PreenchaDados";
import CadastroCampis from "./pages/Cadastro-Campis/CadastroCampis";
import CadastroInstituicao from "./pages/CadastroInstituicao/CadastroInstituicao";
import CadastroCurso from "./pages/Dashboard-Cadastro-Curso/CadastroCurso";
import Profile from "./pages/Profile/Profile";
import Campis from "./pages/Campis/Campis";
import Cursos from "./pages/Cursos/Cursos";
import AreasCurso from "./pages/AreasCurso/AreasCurso";
import CadastroFeito from "./pages/Cadastro-Feito/CadastroFeito";
import DashboardES from "./pages/Modulo2/Dashboard-ES/DashboardES";
import TermoCompromisso from "./pages/Modulo2/TermoCompromisso/TermoCompromisso";
import CadastrarEstabelecimentoSaude from "./pages/Modulo2/Estabelecimentos-Saude/CadastrarEstabelecimentoSaude";
import EstabelecimentosSaude from "./pages/Modulo2/Estabelecimentos-Saude/EstabelecimentosSaude";
import VagasDisponibilizadas from "./pages/Modulo2/Vagas-Disponibilizadas/VagasDisponibilizadas";
import VagasSolicitadas from "./pages/Modulo2/Vagas-Solicitadas/VagasSolicitadas";
import CadastrarVagasEstagio2 from "./pages/Modulo2/Cadastrar-Vagas-Estagio/CadastrarVagasEstagio2";
import SolicitarVagasEstagio from "./pages/Modulo2/Solicitar-Vagas-Estago/SolicitarVagasEstagio";
import CamposSolicitados from "./pages/Modulo2/Campos-Solicitados/CamposSolicitados";
import Contrapartida from "./pages/Modulo2/Contrapartida/Contrapartida";
import ContrapartidaGerada from "./pages/Modulo2/Contrapartida-Gerada/ContrapartidaGerada";
import ContrapartidaUtilizada from "./pages/Modulo2/Contrapartida-Utilizada/ContrapartidaUtilizada";
import Concessoes from "./pages/Modulo2/Concessoes/Concessoes";
import ConfirmarConcessao from "./pages/Modulo2/Confirmar-Concessao/ConfirmarConcessao";
import CadastrarAlunos from "./pages/Modulo2/Cadastrar-Alunos/CadastrarAlunos";
import GerenciarCadastro from "./pages/Modulo2/GerenciarCadastro/GerenciarCadastro";
import UsersPendentes from "./pages/Users/UsersPendentes";
import UsersAtivos from "./pages/Users/UsersAtivos";
import EditarConta from "./pages/EditarConta/EditarConta";
import ConfirmadaDetalhe from "./pages/Modulo2/Confirmadas/ConfirmadaDetalhe";
import RelatorioConcessao from "./pages/Modulo2/Relatorio-Concessao/RelatorioConcessao";
import RelatorioConcessaoDetalhe from "./pages/Modulo2/Relatorio-Concessao/RelatorioConcessaoDetalhe";
import EsqueciSenha from "./pages/RecuperacaoSenha/EsqueciSenha";
import RedefinirSenha from "./pages/RecuperacaoSenha/RedefinirSenha";

const publicRoutes = [
  { path: "/", element: <Login /> },
  { path: "/Cadastro", element: <Cadastro /> },
  { path: "/Video", element: <Video /> },
  { path: "/TermoCooperacao", element: <TermoCooperacao /> },
  { path: "/PreenchaDados", element: <PreenchaDados /> },
  { path: "/CadastroInstituicao", element: <CadastroInstituicao /> },
  { path: "/CadastroFeito", element: <CadastroFeito /> },
  { path: "/esqueci-senha", element: <EsqueciSenha /> },
  { path: "/redefinir-senha", element: <RedefinirSenha /> },
];

const privateRoutes = [
  { path: "/DashboardInicio", element: <DashboardInicio /> },
  { path: "/TextIntro", element: <TextIntro /> },
  { path: "/CadastroCampis", element: <CadastroCampis /> },
  { path: "/CadastroCurso", element: <CadastroCurso /> },
  { path: "/Profile", element: <Profile /> },
  { path: "/Campis", element: <Campis /> },
  { path: "/Cursos", element: <Cursos /> },
  { path: "/AreasCurso", element: <AreasCurso /> },
  { path: "/DashboardES", element: <DashboardES /> },
  { path: "/TermoCompromisso", element: <TermoCompromisso /> },
  { path: "/TermoCompromissoPendentes", element: <TermoCompromisso /> },
  { path: "/CadastrarEstabelecimentoSaude", element: <CadastrarEstabelecimentoSaude /> },
  { path: "/EstabelecimentosSaude", element: <EstabelecimentosSaude /> },
  { path: "/VagasDisponibilizadas", element: <VagasDisponibilizadas /> },
  { path: "/VagasSolicitadas", element: <VagasSolicitadas /> },
  { path: "/EstagioObrigatorio", element: <VagasDisponibilizadas /> },
  { path: "/Residencia", element: <VagasDisponibilizadas /> },
  { path: "/AulaPratica", element: <VagasDisponibilizadas /> },
  { path: "/CadastrarVagasEstagio2", element: <CadastrarVagasEstagio2 /> },
  { path: "/solicitarVaga", element: <SolicitarVagasEstagio /> },
  { path: "/CamposSolicitados", element: <CamposSolicitados /> },
  { path: "/Contrapartida", element: <Contrapartida /> },
  { path: "/ContrapartidaGerada", element: <ContrapartidaGerada /> },
  { path: "/ContrapartidaUtilizada", element: <ContrapartidaUtilizada /> },
  { path: "/Concessoes", element: <Concessoes /> },
  { path: "/ConfirmarConcessao", element: <ConfirmarConcessao /> },
  { path: "/CadastrarAlunos", element: <CadastrarAlunos /> },
  { path: "/Concedidas", element: <Concessoes /> },
  { path: "/Confirmadas", element: <Concessoes /> },
  { path: "/Confirmadas/:solicitacaoId", element: <ConfirmadaDetalhe /> },
  { path: "/RelatorioConcessao/:relatorio", element: <RelatorioConcessao /> },
  { path: "/RelatorioConcessao/:relatorio/:solicitacaoId", element: <RelatorioConcessaoDetalhe /> },
  { path: "/NaoConcedidas", element: <Concessoes /> },
  { path: "/ParaAnalise", element: <Concessoes /> },
  { path: "/UsersPendentes", element: <UsersPendentes /> },
  { path: "/UsersAtivos", element: <UsersAtivos /> },
  { path: "/EditarConta", element: <EditarConta /> },
  { path: "/GerenciarCadastro", element: <GerenciarCadastro /> },
];

export { publicRoutes, privateRoutes };
